export var EDIT_PICKUP_PERSON_ALERT_MESSAGE;
(function (EDIT_PICKUP_PERSON_ALERT_MESSAGE) {
    EDIT_PICKUP_PERSON_ALERT_MESSAGE["ERROR"] = "Something went wrong on our end. Please check back later.";
    EDIT_PICKUP_PERSON_ALERT_MESSAGE["FRAUD_ERROR"] = "We are unable to update your pickup person at this time.";
})(EDIT_PICKUP_PERSON_ALERT_MESSAGE || (EDIT_PICKUP_PERSON_ALERT_MESSAGE = {}));
